import {
  AfterViewInit,
  Component, ComponentRef,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';

import { InteractionService } from '../../../services/interaction.service';
import { SynchronizationService } from '../../../services/synchronization.service';
import { Subscription } from 'rxjs';
import { SettingsService } from '../../../services/settings.service';
import * as $ from 'jquery';
import interact from 'interactjs';
import { AwallComponentEvent } from '../../../models/awallComponentEvent';
import { WBUtils } from './util/WBUtils';
import { SmartWhiteboard } from './smart-whiteboard';
import { WhiteboardIOService } from '../../../services/whiteboard-io.service';
import { ConfigLoaderService } from '../../../config/configloader.service';
import { DrawingMode } from './util/drawing-mode';
import { IWidget } from '../../../interfaces/iWidget';
import { CommunicationService } from '../../../services/communication.service';

@Component({
  selector: 'app-whiteboard-widget',
  templateUrl: './whiteboard-widget.component.html',
  styleUrls: ['./whiteboard-widget.component.scss'],
  })

export class WhiteboardWidgetComponent implements IWidget, OnInit, OnDestroy, AfterViewInit, OnDestroy {
  public static readonly componentId = 'WhiteboardWidgetComponent';
  static widgetName = 'whiteboard';
  public DM = DrawingMode;
  @ViewChild('divcontainer', { static: true }) private element: ElementRef;

  private smartWhiteboard: SmartWhiteboard;

  /** General widget values */
  public isSmallView: boolean;
  private event: Subscription[] = [];
  private isFullScreen: boolean;
  private readonly MIN_WIDTH = 700;
  private readonly MIN_HEIGHT = 500;
  private readonly SAVE_INTERVAL: 5000;
  private readonly SAVE_FADE_TIME = 400;
  private readonly SAVE_FADE_DELAY = 1000;
  private readonly OFFSET_ADJUSTMENT = 12;

  /** Canvas states and values */
  private isVTRMaster: boolean;
  private isVTRSynced: boolean;
  private autoSaveEnabled: boolean;
  private canvasOpaque: boolean;
  private vtrUserCount: number;

  /** Coordinates  */
  private lastW;
  private lastH;
  private lastTransform: number;
  private lastTransformLeft: number;
  private lastDataX: number;
  private lastDataY: number;

  // style
  public zIndex = 25;

  // ref
  public componentRef: ComponentRef<any>;
  public isUndocked: boolean;

  constructor(
    private communicationService: CommunicationService,
    private interactionService: InteractionService,
    private synchronization: SynchronizationService,
    private settingsService: SettingsService,
    private configService: ConfigLoaderService,
    private wbIOService: WhiteboardIOService) {
  }

  ngOnInit() {
    this.initValues();
    this.initStates();
    this.event.push(this.settingsService.getUpdateObservable().subscribe(res => this.updateOnProjectLoad()));
    this.setupRealTimeEvents();
    this.communicationService.registerComponent(WhiteboardWidgetComponent.componentId, this);
  }

  ngOnDestroy(): void {
    for (const ev of this.event) {
      ev.unsubscribe();
    }
    this.communicationService.unregisterComponent(WhiteboardWidgetComponent.componentId);
    this.interactionService.unset(WBUtils.whiteboardWidgetClass);
    interact('.canvas-dropzone').unset();
  }


  private initStates() {
    this.isSmallView = true;
    this.isFullScreen = false;
    this.isVTRMaster = false;
    this.isVTRSynced = false;
    this.autoSaveEnabled = false;
    this.canvasOpaque = false;
  }

  private initValues() {
    this.lastW = '55vw';
    this.lastH = '55vh';
    this.lastTransformLeft = 0;
    this.vtrUserCount = 0;
  }

  ngAfterViewInit() {
    this.setupInteraction();
    this.smartWhiteboard = new SmartWhiteboard(this.synchronization, this.settingsService, this.configService, this.wbIOService);
    this.smartWhiteboard.init(this);
    WBUtils.initJQuerySelectorsAfterInit();
    this.setupAutoSaveInterval();
    this.setupColorPanelHighlighting();
  }

  private setupInteraction() {
    this.setupDragInteractionBlocking();
    this.setupWidgetClickInteraction();
  }

  /**
   * Override the drag interaction of the widget-wrapper on the whiteboard content.
   */
  private setupDragInteractionBlocking() {
    interact('.canvas-dropzone').draggable({
      onstart: event => { },
      onmove: event => { },
      onend: event => { },
    });
  }

  private setupWidgetClickInteraction() {
  }

  /**
   * Sets up the auto save interval, which saves the content of the whiteboard and displays
   * an icon when succesfully saved.
   */
  private setupAutoSaveInterval() {
    /*
    setInterval(() => {
      if (!this.isSmallView && this.autoSaveEnabled) {
        if (this.settingsService.getProjectName().length > 0) {
          this.smartWhiteboard.saveCanvasContentInProject(
            false,
            () => {
              this.smartWhiteboard.renderCanvasAll();
            },
            () => {
              this.showIconAfterSaving();
            });
        }
      }
    }, this.SAVE_INTERVAL);
    */
  }

  /**
   * Sets the highlighting of the color panel optons inside the color and fill dropdown menu.
   */
  private setupColorPanelHighlighting() {
    $(`${WBUtils.colorWrapperClass} ${WBUtils.colorElementClass}`).on('click', (event) => {
      $(`${WBUtils.colorWrapperClass} .${$(event.currentTarget).attr('class').split(' ')[0]}`)
        .removeClass(WBUtils.colorHighlighted);
      $(`${WBUtils.colorWrapperClass} .${$(event.currentTarget).attr('class').split(' ')[1]}`)
        .addClass(WBUtils.colorHighlighted);
    });
    $(`${WBUtils.fillWrapperClass} ${WBUtils.colorElementClass}`).on('click', () => {
      $(`${WBUtils.fillWrapperClass} .${$(event.currentTarget).attr('class').split(' ')[0]}`)
        .removeClass(WBUtils.colorHighlighted);
      $(`${WBUtils.fillWrapperClass} .${$(event.currentTarget).attr('class').split(' ')[1]}`)
        .addClass(WBUtils.colorHighlighted);
    });
  }

  showIconAfterSaving() {
    WBUtils.saveHintElement.fadeIn(this.SAVE_FADE_TIME, (event) => {
      WBUtils.saveHintElement.delay(this.SAVE_FADE_DELAY).fadeOut(this.SAVE_FADE_TIME);
    });
  }

  /**
   * Set up the event listeners for real-time synchronization. Calls all sub-methods.
   */
  private setupRealTimeEvents() {
    this.setupRTEventsVTR();
    this.setupRTEventsCreateObject();
    this.setupRTEventsModifyObject();
    this.setupRTEventsModesAttributes();
    this.setupRTEventsSaveLoad();
  }

  /**
   * Sets up the real time events for statring and ending vtr connections and syncing whiteboard contents.
   */
  private setupRTEventsVTR() {
    this.event.push(this.synchronization.subscribeEvent<any>('WhiteboardWidget' + WBUtils.widgetName + 'StartVTR')
      .subscribe(data => {
        const newUsers = Number(`${data.users}`);
        if (newUsers !== this.vtrUserCount) {
          this.vtrUserCount = newUsers;
          if (this.isVTRMaster) {
            this.smartWhiteboard.sendSyncContents(newUsers);
          }
        }
      }));

    this.event.push(this.synchronization.subscribeEvent<any>('WhiteboardWidget' + WBUtils.widgetName + 'EndVTR')
      .subscribe(data => {
        this.vtrUserCount = this.vtrUserCount - 1;
        if ((`${data.master}` === 'true')) {
          // TODO
        }
      }));

    this.event.push(this.synchronization.subscribeEvent<any>('WhiteboardWidget' + WBUtils.widgetName + 'SyncWhiteboardContent')
      .subscribe(data => {
        const newUsers = Number(`${data.users}`);

        if (newUsers === this.vtrUserCount && !this.isVTRSynced) {
          this.smartWhiteboard.syncContent(data);
        }
      }));
  }

  /**
   * Sets up the real time events for creating and modifying objects on canvas.
   */
  private setupRTEventsCreateObject() {
    let drawingSyncObject;

    this.event.push(this.synchronization.subscribeEvent<any>('WhiteboardWidget' + WBUtils.widgetName + 'DropImage')
      .subscribe(data => {
        this.smartWhiteboard.dropImage(`${data.src}`, Number(`${data.x}`), Number(`${data.y}`));
      }));

    this.event.push(this.synchronization.subscribeEvent<any>('WhiteboardWidget' + WBUtils.widgetName + 'DropPath')
      .subscribe(data => {
        this.smartWhiteboard.dropSyncedPath(data);
      }));

    this.event.push(this.synchronization.subscribeEvent<any>('WhiteboardWidget' + WBUtils.widgetName + 'CreateObject')
      .subscribe(position => {
        drawingSyncObject = this.smartWhiteboard.createObject(Number(`${position.anchorX}`), Number(`${position.anchorY}`));
      }));

    this.event.push(this.synchronization.subscribeEvent<any>('WhiteboardWidget' + WBUtils.widgetName + 'ModifyObject')
      .subscribe(position => {
        this.smartWhiteboard.modifyObject(Number(`${position.anchorX}`), Number(`${position.anchorY}`),
          Number(`${position.eventX}`), Number(`${position.eventY}`));
      }));

    this.event.push(this.synchronization.subscribeEvent<any>('WhiteboardWidget' + WBUtils.widgetName + 'DropObject')
      .subscribe(id => {
        this.smartWhiteboard.copyAndDropObject(Number(`${id.id}`), `${id.awtype}`);
        this.smartWhiteboard.removeObject(drawingSyncObject);
      }));

    this.event.push(this.synchronization.subscribeEvent<any>('WhiteboardWidget' + WBUtils.widgetName + 'UpdateTextObject')
      .subscribe(data => {
        this.smartWhiteboard.getFabricObjectById(Number(`${data.id}`)).set('text', `${data.text}`);
        this.smartWhiteboard.renderCanvasAll();
      }));

    this.event.push(this.synchronization.subscribeEvent<any>('WhiteboardWidget' + WBUtils.widgetName + 'StopTextModify')
      .subscribe(data => {
        this.smartWhiteboard.stopModifyText();
      }));
  }

  /**
   * Sets up the real time events for moving, scaling, rotating, copying and deleting objects on canvas.
   */
  private setupRTEventsModifyObject() {
    this.event.push(this.synchronization.subscribeEvent<any>('WhiteboardWidget' + WBUtils.widgetName + 'MoveObject')
      .subscribe(data => {
        this.smartWhiteboard.moveObject(Number(`${data.id}`), Number(`${data.left}`), Number(`${data.top}`));
      }));

    this.event.push(this.synchronization.subscribeEvent<any>('WhiteboardWidget' + WBUtils.widgetName + 'ScaleObject')
      .subscribe(data => {
        this.smartWhiteboard.scaleObject(Number(`${data.id}`), Number(`${data.scaleX}`), Number(`${data.scaleY}`),
          (`${data.single}` === 'true'), Number(`${data.left}`), Number(`${data.top}`));
      }));

    this.event.push(this.synchronization.subscribeEvent<any>('WhiteboardWidget' + WBUtils.widgetName + 'RotateObject')
      .subscribe(data => {
        this.smartWhiteboard.rotateObject(Number(`${data.id}`), Number(`${data.angle}`));
      }));

    this.event.push(this.synchronization.subscribeEvent<any>('WhiteboardWidget' + WBUtils.widgetName + 'DeleteObject')
      .subscribe(data => {
        this.smartWhiteboard.deleteObjectById(Number(`${data.id}`));
      }));

    this.event.push(this.synchronization.subscribeEvent<any>('WhiteboardWidget' + WBUtils.widgetName + 'CopyObject')
      .subscribe(data => {
        this.smartWhiteboard.copyObjectById((Number(`${data.id}`)));
        this.smartWhiteboard.incrementUniqueElementId();
      }));
  }

  /**
   * Sets up the real time events for changes in states and modes.
   */
  private setupRTEventsModesAttributes() {
    this.event.push(this.synchronization.subscribeEvent<any>('WhiteboardWidget' + WBUtils.widgetName + 'SetDrawingMode')
      .subscribe((mode) => {
        this.smartWhiteboard.setDrawingMode(Number(mode.drawingMode));
      }));

    this.event.push(this.synchronization.subscribeEvent<any>('WhiteboardWidget' + WBUtils.widgetName + 'SetColor')
      .subscribe(color => {
        this.smartWhiteboard.setColor(`${color.color}`);
      }));

    this.event.push(this.synchronization.subscribeEvent<any>('WhiteboardWidget' + WBUtils.widgetName + 'SetFill')
      .subscribe(color => {
        this.smartWhiteboard.setFill(`${color.color}`);
      }));

    this.event.push(this.synchronization.subscribeEvent<any>('WhiteboardWidget' + WBUtils.widgetName + 'SetStrokeWidth')
      .subscribe(width => {
        this.smartWhiteboard.setStrokeWidth(Number(`${width.width}`));
      }));

    this.event.push(this.synchronization.subscribeEvent<any>('WhiteboardWidget' + WBUtils.widgetName + 'ColorElement')
      .subscribe(data => {
        this.smartWhiteboard.colorElement(Number(`${data.id}`), `${data.color}`);
      }));

    this.event.push(this.synchronization.subscribeEvent<any>('WhiteboardWidget' + WBUtils.widgetName + 'FillElement')
      .subscribe(data => {
        this.smartWhiteboard.fillElement(Number(`${data.id}`), `${data.color}`);
      }));

    this.event.push(this.synchronization.subscribeEvent<any>('WhiteboardWidget' + WBUtils.widgetName + 'StrokeElement')
      .subscribe(data => {
        this.smartWhiteboard.strokeElement(Number(`${data.id}`), Number(`${data.width}`));
      }));
  }

  /**
   * Sets up the real time events relating to I/O actions.
   */
  private setupRTEventsSaveLoad() {
    this.event.push(this.synchronization.subscribeEvent<any>('WhiteboardWidget' + WBUtils.widgetName + 'SaveWBProject')
      .subscribe(() => {
        this.smartWhiteboard.saveCanvasContentInProject(
          false,
          () => {
            this.smartWhiteboard.renderCanvasAll();
          }, () => {
            this.showIconAfterSaving();
          });
      }));

    this.event.push(this.synchronization.subscribeEvent<any>('WhiteboardWidget' + WBUtils.widgetName + 'LoadWhiteboard')
      .subscribe(data => {
        this.smartWhiteboard.loadWhiteboard(`${data.url}`, false);
      }));

    this.event.push(this.synchronization.subscribeEvent<any>('WhiteboardWidget' + WBUtils.widgetName + 'NewWhiteboard')
      .subscribe(data => {
        this.smartWhiteboard.modifyCurrentProjectWhiteboard(`${data.newName}`);
      }));
  }

  /**
   * Executed when a JIRA project is loaded successfully.
   */
  updateOnProjectLoad(): void {
    this.smartWhiteboard.setCanvasLoaded(false);
    if (!(this.isVTRSynced && !this.isVTRMaster) && !this.smartWhiteboard.getCanvasLoaded()) {
      this.smartWhiteboard.loadProjectWhiteboards();
    }
  }

  /**
   * Takes an array of whiteboards and fills the values into the dropdown menu "recent".
   * TODO: refactor
   */
  fillHistoryPanel(whiteboards: any) {
    let html = '';
    const deleteBtn = '<div><i class="fa fa-trash"></i></div>';

    whiteboards.forEach((whiteboard, index) => {
      const img = `<img id="hmv${index}"/>`;
      const title = '<p>' + whiteboard.name + '</p>';
      html += `<div class="h-elem" id="${index}" data-id="${whiteboard.id}">${img}${title}${deleteBtn}</div>`;
    });

    $(WBUtils.historyElementsClass).html(html);
    $(WBUtils.historyElementImgAndParagraphClass).on('click', (event) => {
      this.onClickHistoryElement(Number($(event.currentTarget).parent().attr('id')));
    });
    $(WBUtils.historyElementDivClass).on('click', (event) => {
      this.onClickDeleteWhiteboardFile(Number($(event.currentTarget).parent().attr('data-id')));
    });


    whiteboards.forEach((whiteboard, index) => {
      this.fillHistoryMiniView(whiteboard.name, index);
    });

  }

  fillHistoryMiniView(url: string, index: number) {
    const fileUrl = this.smartWhiteboard.getProjectBaseURL().replace('/projects', '/') + url + '?v=' + Date.now();
    const raw = new XMLHttpRequest();

    raw.open('GET', fileUrl, false);
    raw.onreadystatechange = () => {
      if (raw.readyState === 4) {
        if (raw.status === 200 || raw.status === 0) {
          this.smartWhiteboard.getTempCanvas().loadFromJSON(atob(raw.responseText), () => {
            this.smartWhiteboard.getTempCanvas().renderAll();
            $(`#hmv${index}`).attr('src', this.smartWhiteboard.getTempCanvasAsDataURL());
          });
        }
      }
    };
    raw.send(null);
  }

  closeCanvasPreview() {
    WBUtils.canvasPreview.hide();
    WBUtils.canvasContainer.css('display', 'block');
    WBUtils.canvasDropZone.css('overflow', 'hidden');
    WBUtils.closePreviewBtn.css('display', 'none');
    WBUtils.canvasPreview.removeClass(WBUtils.canvasPreviewDraggable);
  }

  /**
   * Called form VTR Widget in order to signal VTR connection start and end.
   */
  onCommunicationEvent(event: AwallComponentEvent): void {
    if (!event) { return; }

    switch (event.name) {
      case 'connectedVTR':
        this.vtrUserCount = Number(event.value);
        if (this.vtrUserCount === 0) {
          this.isVTRMaster = true;
          this.isVTRSynced = true;
        }
        this.synchronization.sendRealTimeEvent('WhiteboardWidget' + WBUtils.widgetName + 'StartVTR', {
          users: Number(event.value)
        });
        break;

      case 'disconnectedVTR':
        this.isVTRSynced = false;
        this.vtrUserCount = 0;
        if (this.isVTRMaster) {
          this.isVTRMaster = false;
        }
        this.synchronization.sendRealTimeEvent('WhiteboardWidget' + WBUtils.widgetName + 'EndVTR', {
          master: this.isVTRMaster
        });
        break;
    }
  }

  onClickResetWidget(event: any) {
    this.synchronization.sendRealTimeEvent('WhiteboardWidget' + WBUtils.widgetName + 'ResetWidget');
    const closest = event.target.closest(`.${WBUtils.interactedClass}`);
    this.resetWidget(closest);
  }

  resetWidget(target: HTMLElement) {
    WBUtils.toolButton.hide();
    this.interactionService.undoDragInteraction(target);
    target.classList.remove(WBUtils.interactedClass);
    this.isSmallView = true;
    this.isFullScreen = false;
    this.smartWhiteboard.updateMiniCanvasPreview();
    WBUtils.canvasPreview.css('border-color', '#ffffff');
    WBUtils.canvasContainer.hide();
    WBUtils.canvasDropZone.css('overflow', 'visible');
    WBUtils.canvasPreview.removeClass(WBUtils.canvasPreviewDraggable);
  }

  onClickFullscreen(event: any) {
    this.toggleFullScreen();
    this.synchronization.sendRealTimeEvent('WhiteboardWidget' + WBUtils.widgetName + 'FullScreen');
  }

  private toggleFullScreen() {
    const target = this.element.nativeElement;
    if (!this.isFullScreen) {
      this.setFullScreen(target);
    } else {
      this.exitFullScreen(target);
    }
  }

  /**
   * Sets the widget to full screen mode.
   */
  private setFullScreen(target: any) {
    const offsetLeft = WBUtils.whiteboardWidget.offset().left;
    const offsetTop = WBUtils.whiteboardWidget.offset().top;
    const currTrans = target.style.transform.split(/[()]/)[1];
    const transX = currTrans.split(',')[4];
    const transY = currTrans.split(',')[5];

    this.lastW = target.style.width;
    this.lastH = target.style.height;
    this.lastTransform = target.style.transform;
    this.lastDataX = target.getAttribute('data-x');
    this.lastDataY = target.getAttribute('data-y');

    target.setAttribute('data-x', transX - offsetLeft);
    target.setAttribute('data-y', transY - offsetTop);
    target.style.transform = 'matrix(1, 0, 0, 1, ' + (transX - offsetLeft) + ', ' + (transY - offsetTop) + ')';
    target.style.width = '100vw';
    target.style.height = '100vh';
    this.isFullScreen = true;
    $(`${WBUtils.fullScreenButtonClass} ${WBUtils.fsInner}`).html('fullscreen_exit');
  }

  /**
   * Resets the widget from fullscreen to last positon.
   */
  private exitFullScreen(target: any) {
    target.setAttribute('data-x', this.lastDataX);
    target.setAttribute('data-y', this.lastDataY);
    target.style.transform = this.lastTransform;
    target.style.width = this.lastW;
    target.style.height = this.lastH;
    this.isFullScreen = false;
    $(`${WBUtils.fullScreenButtonClass} ${WBUtils.fsInner}`).html('fullscreen');
  }

  onClickSetDrawingMode(drawingMode: DrawingMode) {
    this.smartWhiteboard.setDrawingMode(drawingMode);
    this.synchronization.sendRealTimeEvent('WhiteboardWidget' + WBUtils.widgetName + 'SetDrawingMode', {
      drawingMode: drawingMode
    });
  }

  onClickClearCanvas() {
    this.smartWhiteboard.clearCanvas(true);
    $(WBUtils.selectionContextClass).hide();
  }

  onClickColor() {
    if ($(WBUtils.colorWrapperClass).is(':visible')) {
      $(WBUtils.colorWrapperClass).slideUp();
    } else {
      $(WBUtils.colorWrapperClass).slideDown();
    }
    this.closeOthers(WBUtils.colorWrapperClass);
  }

  onClickSetColor(color: string) {
    this.smartWhiteboard.setColor(color);
    this.synchronization.sendRealTimeEvent('WhiteboardWidget' + WBUtils.widgetName + 'SetColor', {
      color: color
    });
    $(WBUtils.colorWrapperClass).slideUp();
    $(WBUtils.strokeCircleClass).css('background', color);
  }

  onClickFill(event: any) {
    if ($(WBUtils.fillWrapperClass).is(':visible')) {
      $(WBUtils.fillWrapperClass).slideUp();
    } else {
      $(WBUtils.fillWrapperClass).slideDown();
    }
    this.closeOthers(WBUtils.fillWrapperClass);
  }

  onClickSetFill(color: string) {
    this.smartWhiteboard.setFill(color);
    this.synchronization.sendRealTimeEvent('WhiteboardWidget' + WBUtils.widgetName + 'SetFill', {
      color: color
    });
    $(WBUtils.fillWrapperClass).slideUp();
  }

  onClickStroke() {
    if ($(WBUtils.strokeWrapperClass).is(':visible')) {
      $(WBUtils.strokeWrapperClass).slideUp();
    } else {
      $(WBUtils.strokeWrapperClass).slideDown();
    }
    this.closeOthers(WBUtils.strokeWrapperClass);
  }

  onStrokeChange() {
    const width = $(WBUtils.strokeRangeID).val();
    $(WBUtils.strokeCircleClass).css({
      'width': width + 'px',
      'height': width + 'px',
      'border-radius': width + 'px'
    });
    this.smartWhiteboard.setStrokeWidth(Number(width));
  }

  onToggleAutosave() {
    this.autoSaveEnabled = !this.autoSaveEnabled;
  }

  onToggleOpacity() {
    this.canvasOpaque = !this.canvasOpaque;
    if (this.canvasOpaque) {
      $(WBUtils.whiteboardWidgetClass).css('opacity', 0.6);
    } else {
      $(WBUtils.whiteboardWidgetClass).css('opacity', 1);
    }
  }

  onToggleSnap() {
    this.smartWhiteboard.toggleSnap();
  }

  onClickRecent() {
    if ($(WBUtils.historyWrapperClass).is(':visible')) {
      $(WBUtils.historyWrapperClass).slideUp();
    } else {
      $(WBUtils.historyWrapperClass).slideDown();
    }
    this.closeOthers(WBUtils.historyWrapperClass);
  }

  onClickHistoryElement(i: number) {
    this.smartWhiteboard.setCanvasLoaded(false);
    this.smartWhiteboard.loadWhiteboard(this.wbIOService.getWhiteboards()[i].url, true);
    $(WBUtils.historyWrapperClass).slideUp();
  }

  onClickSaveBoard() {
    if (this.settingsService.getProjectName().length > 0) {
      this.smartWhiteboard.saveCanvasContentInProject(
        false,
        () => {
          this.smartWhiteboard.renderCanvasAll();
        },
        () => {
          this.showIconAfterSaving();
        });
    }
  }

  onClickNewBoard() {
    this.prepareNewBoard(true);
  }

  /**
   * Saves the current openend board, initiates a new one and saves this too.
   */
  prepareNewBoard(originalInvoker: boolean) {
    this.saveOldBoardBeforeCreationOfNew(originalInvoker);
    this.smartWhiteboard.clearCanvas(true);

    if (originalInvoker) {
      this.smartWhiteboard.createNewProjectWhiteBoard();
    }

    this.saveNewlyCreatedBoard(originalInvoker);
    this.synchronization.sendRealTimeEvent('WhiteboardWidget' + WBUtils.widgetName + 'NewWhiteboard', {
      newName: this.smartWhiteboard.getCurrentProjectWhiteboard()
    });
  }

  private saveOldBoardBeforeCreationOfNew(originalInvoker: boolean) {
    this.smartWhiteboard.saveCanvasContentInProject(
      originalInvoker,
      () => {
        this.smartWhiteboard.renderCanvasAll();
      },
      () => {
        this.showIconAfterSaving();
      });
  }

  private saveNewlyCreatedBoard(originalInvoker: boolean) {
    this.smartWhiteboard.saveCanvasContentInProject(
      originalInvoker,
      (wbs) => {
        this.fillHistoryPanel(wbs);
        this.smartWhiteboard.renderCanvasAll();
      },
      () => {
        this.showIconAfterSaving();
      });
  }

  onClickDeleteWhiteboardFile(i: number) {
    const projectKey = this.settingsService.getProjectName();
    const deleteUrl = this.smartWhiteboard.getProjectBaseURL() + `/${projectKey}/widgets/whiteboard/project/${i}/`;

    this.wbIOService.deleteWhiteboard(deleteUrl, projectKey, (response) => {
      this.smartWhiteboard.loadProjectWhiteboards();
    }, (error) => {
      console.log(error);
    });
  }

  onClickDeleteElement() {
    this.smartWhiteboard.getSelectedElementIds().forEach((id) => {
      this.synchronization.sendRealTimeEvent(
        `WhiteboardWidget${WBUtils.widgetName}DeleteObject`, {
          id: id
        });
    });
    this.smartWhiteboard.deleteSelectedElement();
    $(WBUtils.selectionContextClass).hide();
  }

  onClickNewStory() {
    alert('coming');
  }

  /**
   * Closes all dropdown menus on the whiteboard excluding the element 'exclude'
   */
  public closeOthers(exclude: string) {
    const wrappers = [WBUtils.colorWrapperClass, WBUtils.fillWrapperClass, WBUtils.historyWrapperClass, WBUtils.strokeWrapperClass];
    for (const s of wrappers) {
      if (s !== exclude) {
        if ($(s).is(':visible')) {
          $(s).slideUp();
        }
      }
    }
  }

  highlightToolButton(button: any) {
    $(WBUtils.labelButtonClass).removeClass(WBUtils.labelButtonSelectedClass);
    $(button).addClass(WBUtils.labelButtonSelectedClass);
  }

  getIsSmallView(): boolean {
    return this.isSmallView;
  }

  setIsSmallView(isSmallView: boolean) {
    this.isSmallView = isSmallView;
  }

  getIsFullScreen(): boolean {
    return this.isFullScreen;
  }

  setIsFullScreen(isFullScreen: boolean) {
    this.isFullScreen = isFullScreen;
  }

  setWhiteboardStateLabel(currentWhiteboard: string) {
    WBUtils.whiteboardStateLabel.html(currentWhiteboard);
  }

  setIsVTRSynced(isVTRSynced: boolean) {
    this.isVTRSynced = isVTRSynced;
  }

  getTarget(): any {
    return this.element.nativeElement;
  }

  setPosition(x: number, y: number) {
    this.element.nativeElement.style.left = x + 'px';
    this.element.nativeElement.style.top = y + 'px';
  }
}
